import packageJson from "../../package.json";

export const thousandAndDecimalFormat = (data, allowDecimal, decimalScale) => {
  let decimalPoint = allowDecimal ? (decimalScale ? decimalScale : 0) : 0;
  return (isNaN(data)) ? Number.parseFloat(0).toFixed(decimalPoint).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : Number.parseFloat(data).toFixed(decimalPoint).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const getVersion = () => {
  return packageJson?.version ? packageJson.version : "1.0.0";
}